import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const MobileChromeContext = createContext({
  bottomNavHidden: false,
  setBottomNavHidden: () => {},
});

/**
 * Lets nested routes (e.g. Trade chart fullscreen) hide the persistent mobile bottom nav
 * without unmounting AuthenticatedMobileShell.
 */
export function MobileChromeProvider({ children }) {
  const [bottomNavHidden, setBottomNavHiddenState] = useState(false);
  const setBottomNavHidden = useCallback((hidden) => {
    setBottomNavHiddenState(Boolean(hidden));
  }, []);

  const value = useMemo(
    () => ({ bottomNavHidden, setBottomNavHidden }),
    [bottomNavHidden, setBottomNavHidden]
  );

  return (
    <MobileChromeContext.Provider value={value}>
      {children}
    </MobileChromeContext.Provider>
  );
}

export function useMobileChrome() {
  return useContext(MobileChromeContext);
}

export default MobileChromeContext;
